export const QuestionActionTypes={
    SET_FETCHED_QUESTIONS_TO_STATE_XENATUS:'SET_FETCHED_QUESTIONS_TO_STATE_XENATUS',
    SET_SELECTED_QUESTION_XENATUS:'SET_SELECTED_QUESTION_XENATUS',
    SELECTED_QUESTION_NEXT_XENATUS:'SELECTED_QUESTION_NEXT_XENATUS',
    SELECTED_QUESTION_PREVIOUS_XENATUS:'SELECTED_QUESTION_PREVIOUS_XENATUS',
    SET_SELECTED_ANSWER_XENATUS:'SET_SELECTED_ANSWER_XENATUS',
    // SET_RECENT_FETCHED_TIME:"SET_RECENT_FETCHED_TIME"
}